import type { CompanyType, Roles } from '~/prisma/generated/client'
import type { Options } from '~/types/index'

export const appName = 'Thavorn CAL'
export const appDescription = 'Thavorn CAL'

export const maxSizePerPage = 2

export const roles: Options<Roles> = [
  {
    value: 'SALES',
    label: 'Sales',
  },
  {
    value: 'ADMIN',
    label: 'Admin',
  },
  {
    value: 'SUPER_ADMIN',
    label: 'Super Admin',
  },
]

export const companyTypes: Options<CompanyType> = [
  {
    value: 'ENGINE_OIL',
    label: 'น้ำมันเครื่อง',
  },
  {
    value: 'MEDICINES_SUPPLEMENTS',
    label: 'ยาและอาหารเสริม',
  },
  {
    value: 'FOOD',
    label: 'อาหาร',
  },
  {
    value: 'DRINK',
    label: 'เครื่องดื่ม',
  },
  {
    value: 'CAR_TIRE',
    label: 'ยางรถยนต์',
  },
  {
    value: 'COSMETICS',
    label: 'เครื่องสำอาง',
  },
  {
    value: 'CHEMICALS',
    label: 'เคมีภัณฑ์และเคมีเกษตร',
  },
  {
    value: 'CONSUMPTION',
    label: 'อุปโภค',
  },
  {
    value: 'ELECTRONIC',
    label: 'อีเลคโทรนิค',
  },
  {
    value: 'OTHERS',
    label: 'อื่นๆ',
  },
]

export const optionsPriceTax = [
  {
    value: false,
    label: 'ราคาไม่รวมภาษี',
  },
  {
    value: true,
    label: 'ราคารวมภาษี',
  },
]
